/**
 * HUB-H — KPI équipe / audit.
 */
import React from 'react';

export default function ActiviteEquipeKpiStrip({ kpis }) {
  return (
    <div className="space-y-3" data-testid="activite-equipe-kpi">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-xs text-[var(--rm-gray-500)]">Périmètre :</span>
        <span className="rm-badge rm-badge--muted" data-testid="activite-equipe-scope-carlos">Supervision Carlos-only</span>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 text-sm">
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-equipe-logs">
          <div className="text-xs text-[var(--rm-gray-500)]">Journal (période)</div>
          <div className="font-bold text-[var(--rm-white)]">{kpis?.totalLogs ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-equipe-critical">
          <div className="text-xs text-[var(--rm-gray-500)]">Critiques</div>
          <div className="font-bold text-[var(--rm-red-light)]">{kpis?.critical ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-equipe-warning">
          <div className="text-xs text-[var(--rm-gray-500)]">Attention</div>
          <div className="font-bold text-[var(--rm-gray-200)]">{kpis?.warning ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-equipe-alerts">
          <div className="text-xs text-[var(--rm-gray-500)]">Alertes fraude</div>
          <div className="font-bold text-[var(--rm-red-light)]">{kpis?.alerts ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-equipe-security">
          <div className="text-xs text-[var(--rm-gray-500)]">Sécurité</div>
          <div className="font-bold text-[var(--rm-white)]">{kpis?.securityEvents ?? 0}</div>
        </div>
        <div className="rounded-xl border p-3" style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }} data-testid="activite-kpi-equipe-bans">
          <div className="text-xs text-[var(--rm-gray-500)]">IP bannies</div>
          <div className="font-bold text-[var(--rm-gray-200)]">{kpis?.activeBans ?? 0}</div>
        </div>
      </div>
    </div>
  );
}
